import { render, staticRenderFns } from "./sk_kelahiran_aytdau.vue?vue&type=template&id=0868a14c&"
import script from "./sk_kelahiran_aytdau.vue?vue&type=script&lang=js&"
export * from "./sk_kelahiran_aytdau.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPageContainer,QCard,QCardSection,QBtn,QInput,QMarkupTable,QItem,QItemSection,QItemLabel,QTooltip,QBadge,QExpansionItem,QList,QIcon,QSpinnerPie,QPagination,QSelect,QSpinnerFacebook,QSeparator,QFile,QDialog,QCardActions,QEditor,QChatMessage,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPageContainer,QCard,QCardSection,QBtn,QInput,QMarkupTable,QItem,QItemSection,QItemLabel,QTooltip,QBadge,QExpansionItem,QList,QIcon,QSpinnerPie,QPagination,QSelect,QSpinnerFacebook,QSeparator,QFile,QDialog,QCardActions,QEditor,QChatMessage})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
